import reducer from "./reducers";
export { default as backdropActions } from "./actions";

export default reducer;